import { QUESTION_TYPES } from '@api/instant_survey';
import { getQuestionTypeIcon, getQuestionTypeName } from '@helpers';
import { Card, Layout, Pill, sanitizeRichText } from '@utilities';

import { PreviewButton } from '../../../../../../components/SurveyPreview';
import type { MergedExternalQuestion } from '../../../../utilities/types';

import styles from './_index.module.scss';

interface QuestionnaireProps {
  canPreviewSurvey: boolean;
  isPreviewButtonDisabled: boolean;
  onPreviewButtonClick: () => void;
  surveyQuestions: MergedExternalQuestion[];
}

const Questionnaire = ({
  canPreviewSurvey,
  isPreviewButtonDisabled,
  onPreviewButtonClick,
  surveyQuestions,
}: QuestionnaireProps) => {
  return (
    <div>
      <div className={styles['questionnaire-header']}>
        <h3>Questionnaire</h3>
        {canPreviewSurvey && (
          <PreviewButton
            isDisabled={isPreviewButtonDisabled}
            location="survey details"
            onClick={() => onPreviewButtonClick()}
          />
        )}
      </div>
      <Layout.Flex.Column as="ol" gap="small">
        {surveyQuestions?.map((question, index) => {
          const effectiveType = question?.turf ? QUESTION_TYPES.TURF.value : question?.type;
          const TypeIcon = getQuestionTypeIcon(effectiveType) as React.ReactNode;
          const typeName = getQuestionTypeName(effectiveType);
          const questionLabelHtml = sanitizeRichText(
            question?.richText || question?.title || question?.text || `Question ${index + 1}`
          );
          return (
            <li key={question.id}>
              <Card as={Layout.Flex} className={styles['questionnaire-question']} elevation={1}>
                <div>
                  <strong>{index + 1}</strong>
                </div>
                <Layout.Flex.Column>
                  <Layout.Flex className={styles['questionnaire-question-body']} gap="small">
                    <Layout.Fill>
                      <div dangerouslySetInnerHTML={{ __html: questionLabelHtml }} />
                    </Layout.Fill>
                    <div>
                      <Pill icon={TypeIcon} isCompleted value={typeName} />
                    </div>
                  </Layout.Flex>
                </Layout.Flex.Column>
              </Card>
            </li>
          );
        })}
        {surveyQuestions?.length === 0 && <p>No questions are assigned to this survey.</p>}
      </Layout.Flex.Column>
    </div>
  );
};

export default Questionnaire;
